module.exports = __webpack_public_path__ + "img/kpler-logo-cad5de.4e150928.svg";